<mat-nav-list class="sd_bar">
  <button class="closeSidebar" (click)="toggleSidenav()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="logo-brand">
    <figure class="logo" routerLink="/tutor/dashboard">
      <img src="{{ assetsConst.logo1 }}" alt="logo" />
    </figure>
  </div>
  <div class="sidebar1">
    <div *ngFor="let item of sideBar">
      <ng-container *ngIf="!item.isSubMenu">
        <mat-list-item
          [routerLink]="item.path"
          routerLinkActive="active"
          matTooltip="{{ item.text }}"
          matTooltip="Tooltip!"
          matTooltipPosition="right"
          (click)="toggleSidenav()">
          <figure class="sd_cn">
            <img src="{{ item.img }}" alt="" />
          
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.text | translate }}</h5>
          </div>
        </mat-list-item>
      </ng-container>
      <mat-accordion *ngIf="item.isSubMenu">
        <mat-expansion-panel class="drop_lst_nv">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-list-item
                matTooltip="{{ item.text }}"
                matTooltip="Tooltip!"
                matTooltipPosition="right"
                (click)="toggleSidenav()">
                <figure class="sd_cn" mat-raised-button>
                  <img src="{{ item.img }}" alt="" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ item.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list-item
            *ngFor="let sub of item.subMenuItems"
            [routerLink]="sub.path"
            matTooltip="{{ item.text }}"
            matTooltip="Tooltip!"
            matTooltipPosition="right"
            routerLinkActive="active"
            (click)="toggleSidenav()">
            <figure class="sd_cn">
              <img src="{{ sub.img }}" alt="images" />
            </figure>
            <div class="sidenav-item">
              <h5 class="lead">{{ sub.text | translate }}</h5>
            </div>
          </mat-list-item>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="sidebar2">
    <div *ngFor="let item of sideBar2">
      <ng-container *ngIf="!item.isSubMenu">
        <mat-list-item
          [routerLink]="item.path"
          routerLinkActive="active"
          matTooltip="{{ item.text }}"
          matTooltip="Tooltip!"
          matTooltipPosition="right"
          (click)="toggleSidenav()">
          <figure class="sd_cn">
            <img src="{{ item.img }}" alt="logo" />           
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.text | translate }}
            @if (item.sideBarId === SideBar2Const.Communication && chatNotificationCount && chatNotificationCount > 0) {
              <span class="badge">{{ chatNotificationCount }}</span>
            }
            @if (item.sideBarId === SideBar2Const.Notification && notificationCount && notificationCount > 0) {
              <span class="badge">{{ notificationCount }}</span>
            }
            </h5>
          </div>
        </mat-list-item>
      </ng-container>
      <mat-accordion *ngIf="item.isSubMenu">
        <mat-expansion-panel class="drop_lst_nv">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-list-item
                matTooltip="{{ item.text }}"
                matTooltip="Tooltip!"
                matTooltipPosition="right"
                (click)="toggleSidenav()">
                <figure class="sd_cn" mat-raised-button>
                  <img src="{{ item.img }}" alt="" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ item.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list-item
            *ngFor="let sub of item.subMenuItems"
            [routerLink]="sub.path"
            matTooltip="{{ item.text }}"
            matTooltip="Tooltip!"
            matTooltipPosition="right"
            routerLinkActive="active"
            (click)="toggleSidenav()">
            <figure class="sd_cn">
              <img src="{{ sub.img }}" alt="images" />
            </figure>
            <div class="sidenav-item">
              <h5 class="lead">{{ sub.text | translate }}</h5>
            </div>
          </mat-list-item>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</mat-nav-list>
